import React from 'react';

import PropTypes from 'prop-types';
import FaCaretDown from 'react-icons/lib/fa/caret-down';
import FaCaretUp from 'react-icons/lib/fa/caret-up';

function InputCaret(props) {
    const {
        className,
        isActive,
        onClick,
        ...otherProps
    } = props;
    const Icon = isActive
        ? FaCaretUp
        : FaCaretDown;

    return (
        <span className={className} onClick={onClick}>
            <Icon {...otherProps} />
        </span>
    );
}

InputCaret.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
};

InputCaret.defaultProps = {
    className: '',
    isActive: false,
    onClick() {},
};

export default InputCaret;
